import { businessTokens, type DimensionId } from "@benyishiguang/ui-foundation";
import { Sparkles, SunMedium, UsersRound, Leaf, Send, type LucideIcon } from "lucide-react";
export type Dimension = {
	id: DimensionId;
	name: string;
	short: string;
	Icon: LucideIcon;
	color: string;
	soft: string;
	deep: string;
	tag: string;
	blurb: string;
};

const DIMENSION_ICONS = {
	aware: Sparkles,
	strength: SunMedium,
	relate: UsersRound,
	resil: Leaf,
	hope: Send,
};
export const DIMENSIONS: Dimension[] = businessTokens.dimensions.map((dimension) => ({
	...dimension,
	Icon: DIMENSION_ICONS[dimension.id],
	color: "var(--brand-primary)",
	soft: "var(--brand-warm)",
	deep: "var(--brand-ink)",
}));

export const DIM = Object.fromEntries(
	DIMENSIONS.map((dimension) => [dimension.id, dimension]),
) as Record<DimensionId, Dimension>;
